import jsonBigint from 'json-bigint'

export const jsonBig = jsonBigint({
  storeAsString: true,
})
